
export default function LocationSection() {
  return (
    <section id="location" className="py-14 md:py-20 bg-[#f7f7f5]">
      <div className="max-w-6xl mx-auto px-5 md:px-12">
        <div className="text-center mb-10 md:mb-12">
          <h2
            className="text-[1.6rem] md:text-5xl font-bold text-[#1a2332] mb-4 md:mb-4"
            style={{ fontFamily: 'Noto Serif KR, serif' }}
          >
            학원 위치 안내
          </h2>
          <p className="text-[15px] md:text-lg text-gray-600 leading-relaxed">
            편리한 교통과 쾌적한 학습 환경을 제공합니다
          </p>
        </div>

        <div className="flex flex-col gap-5 md:gap-6">
          {/* 주소 & 연락처 - 가로 배치 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {/* 주소 */}
            <div className="bg-white rounded-2xl p-6 md:p-6 shadow-lg">
              <div className="flex items-start gap-4 md:gap-4">
                <div className="w-14 h-14 md:w-14 md:h-14 bg-[#4ecdc4]/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl md:text-2xl text-[#4ecdc4]"></i>
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-bold text-[#1a2332] mb-2 md:mb-2">주소</h3>
                  <p className="text-[15px] md:text-lg text-gray-700 mb-1 md:mb-1 leading-relaxed">경기도 파주시 청암로17번길 55</p>
                  <p className="text-[15px] md:text-lg text-gray-700 leading-relaxed">5층 열린학원</p>
                </div>
              </div>
            </div>

            {/* 연락처 */}
            <div className="bg-white rounded-2xl p-6 md:p-6 shadow-lg">
              <div className="flex items-start gap-4 md:gap-4">
                <div className="w-14 h-14 md:w-14 md:h-14 bg-[#ff6b6b]/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl md:text-2xl text-[#ff6b6b]"></i>
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-bold text-[#1a2332] mb-2 md:mb-2">연락처</h3>
                  <p className="text-[15px] md:text-lg text-gray-700 mb-1 md:mb-1 leading-relaxed">전화: 031-947-2018</p>
                  <p className="text-[15px] md:text-lg text-gray-700 leading-relaxed">이메일: rlgnsl98@naver.com</p>
                </div>
              </div>
            </div>
          </div>

          {/* 운영 시간 */}
          <div className="bg-white rounded-2xl p-6 md:p-6 shadow-lg">
            <div className="flex items-start gap-4 md:gap-4">
              <div className="w-14 h-14 md:w-14 md:h-14 bg-[#ffd93d]/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-2xl md:text-2xl text-[#f59e0b]"></i>
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-bold text-[#1a2332] mb-2 md:mb-2">운영 시간</h3>
                <div className="flex flex-col md:flex-row md:flex-wrap gap-1.5 md:gap-x-8 md:gap-y-1">
                  <p className="text-[15px] md:text-lg text-gray-700 leading-relaxed">평일: 오후 1시&nbsp;~ 오후 10시</p>
                  <p className="text-[15px] md:text-lg text-gray-700 leading-relaxed">토요일: 오후 1시 - 오후 6시</p>
                  <p className="text-[15px] md:text-lg text-gray-700 leading-relaxed">일요일: 휴무</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
